import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import { Box, Typography } from "@mui/material";

import { ASSISTANT_NAME } from "../../constants";
import {
  AssistantGuideButton,
  AssistantGuideHint,
  StyledAssistantGuideListTypographyDisplay,
} from "./styles";
import { IAssistantGuideListProps } from "./types";
import { getAssistantGuideLinks } from "./utils";

const AssistantGuideList: React.FC<IAssistantGuideListProps> = ({
  guides,
  showHeading = true,
}) => {
  const links = getAssistantGuideLinks(guides);

  return (
    <>
      {showHeading && (
        <Typography variant="subtitle8">Walk through this task</Typography>
      )}
      {links.map((guide) => (
        <AssistantGuideButton
          key={guide.id}
          variant="outlined"
          startIcon={<RouteOutlinedIcon />}
          endIcon={<ArrowForwardIcon />}
          href={guide.href}
          target="_blank"
          rel="noopener noreferrer"
          disabled={!guide.href}
          aria-label={`${guide.title} walkthrough (opens in a new tab)`}
        >
          <Box>
            <StyledAssistantGuideListTypographyDisplay
              variant="subtitle8"
              component="span"
            >
              {guide.title}
            </StyledAssistantGuideListTypographyDisplay>
            <AssistantGuideHint variant="subtitle9">
              Open in a new tab with {ASSISTANT_NAME}
            </AssistantGuideHint>
          </Box>
        </AssistantGuideButton>
      ))}
    </>
  );
};

export default AssistantGuideList;
